// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class CsvImportView extends JQueryView {
  constructor() {
    super('.simple_form');
    $('#next').prop('disabled', true);
  }

  @on({ event: 'dragenter dragover', selector: '#drop_zone' })
  onEnterDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'dragleave', selector: '#drop_zone' })
  onLeaveDropZone(event: any) {
    event.preventDefault();
  }

  @on({ event: 'drop', selector: '#drop_zone' })
  onDropDropZone(event: any) {
    event.preventDefault();
    $(
      'input[name="stakeholder_stockholder_csv_import_form[file]"]:file',
    )[0].files = event.originalEvent.dataTransfer.files;
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'input[name="stakeholder_stockholder_csv_import_form[file]"]:file',
  })
  changeInputFile() {
    this.render();
  }

  @on({
    event: 'click',
    selector: '#delete-file-btn',
  })
  removeFile() {
    $('#stakeholder_stockholder_csv_import_form_file').val('');
    $('#js-file-container').addClass('invisible');
    $('#next').prop('disabled', true);
  }

  render() {
    const file = $('#stakeholder_stockholder_csv_import_form_file').prop(
      'files',
    )[0];
    if (file.type === 'text/csv') {
      $('#filename').text(file.name);
      $('#js-file-container').removeClass('invisible');
      $('#next').prop('disabled', false);
    }
  }
}
